import { IApplicationState } from '@store'

export const selectSnapMetricsSummary = (state: IApplicationState, campaignId: number) => {
  return state.reportings.snapMetrics.snapMetricsSummaryByCampaignId[campaignId] ?? {}
}

export const selectSnapMetricIds = (state: IApplicationState, campaignId: number) =>
  state.reportings.snapMetrics.snapMetricIdsByCampaignId[campaignId] ?? []

export const selectSnapMetrics = (state: IApplicationState, id: number) =>
  state.reportings.snapMetrics.snapMetricsById[id] ?? {}
